import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const DISPUTE_RESOLUTION_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "dispute_resolution_description",
    label: "Dispute Resolution",
    type: ColumnTypes.string,
    width: 200,
    render: (item) => {
        if (!item.isAsset) return null;

        const value = item.dispute_resolution_description;
        if (!value) return <Emdash />;

        return <span className="dg-overflow">{value}</span>;
    },
};
